/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_View_ErrorInputs */

const en_doc_view_error = /** @type {(inputs: Doc_View_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not open the document. Please try again.`)
};

const pt_br2_doc_view_error = /** @type {(inputs: Doc_View_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível abrir o documento. Tente novamente.`)
};

/**
* | output |
* | --- |
* | "Could not open the document. Please try again." |
*
* @param {Doc_View_ErrorInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_view_error = /** @type {((inputs?: Doc_View_ErrorInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_View_ErrorInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_view_error(inputs)
	return pt_br2_doc_view_error(inputs)
});